import React from "react";
import { logoLight } from "../../assets";

const Loading = () => {
	return (
		<div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-6 text-center">
			<div className="flex flex-col items-center space-y-12">
				{/* Animated Logo Container */}
				<div className="relative">
					{/* Decorative glowing background effect */}
					<div className="absolute -inset-12 bg-brand-500/5 rounded-full blur-3xl animate-pulse" />
					
					<img
						src={logoLight}
						alt="Logo"
						className="relative w-48 md:w-56 h-auto drop-shadow-sm animate-pulse duration-1000"
					/>
				</div>

				{/* Loading Progress Indicator */}
				<div className="flex flex-col items-center space-y-4">
					<div className="flex space-x-2">
						<div className="w-2 h-2 bg-brand-600 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
						<div className="w-2 h-2 bg-brand-600 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
						<div className="w-2 h-2 bg-brand-600 rounded-full animate-bounce"></div>
					</div>
					<p className="text-gray-400 text-[10px] font-black uppercase tracking-[0.5em] translate-x-1">
						Please Wait
					</p>
				</div>
			</div>
		</div>
	);
};

export default Loading;
